import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children", "domainName"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["children"],
  _excluded9 = ["children"];
import { TitleDisplay } from './TitleDisplay';
import { Box, Button, Divider } from '@wix/design-system';
import s from './SearchRecommendation.module.scss';
import React from 'react';
import { Label } from './Label';
import { SearchRecommendationListSkeleton } from './SearchRecommendationSkeleton';
import { PricingContent } from '../Pricing/PricingContent';
const SearchRecommendationSharedProps = {
  overflow: 'hidden',
  align: 'space-between',
  verticalAlign: 'middle',
  padding: 'SP4',
  gap: 'SP4',
  borderRadius: '12px'
};
export const SearchRecommendationLayout = {
  SearchRecommendationContainer: _ref => {
    let children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, {
      className: s.searchRecommendationContainer
    }, props), children);
  },
  SearchRecommendationSkeletonContainer: _ref2 => {
    let children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, {
      className: s.searchRecommendationContainer
    }, props), children);
  },
  DomainInfoContainer: _ref3 => {
    let children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2",
      margin: "8px 0"
    }, props), children);
  },
  SearchRecommendationListContainer: _ref4 => {
    let children = _ref4.children,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      display: "flex",
      width: "100%",
      flex: 1
    }, props), children);
  },
  Skeleton: _ref5 => {
    let limit = _ref5.limit,
      useMobileLayout = _ref5.useMobileLayout,
      defaultNonHovered = _ref5.defaultNonHovered,
      optimized = _ref5.optimized;
    return /*#__PURE__*/React.createElement(SearchRecommendationListSkeleton, {
      limit: limit,
      useMobileLayout: useMobileLayout,
      defaultNonHovered: defaultNonHovered,
      optimized: optimized
    });
  },
  GetItButtonContainer: _ref6 => {
    let children = _ref6.children;
    return /*#__PURE__*/React.createElement(Box, {
      className: s.button
    }, children);
  },
  GetItButton: _ref7 => {
    let children = _ref7.children,
      _domainName = _ref7.domainName,
      props = _objectWithoutPropertiesLoose(_ref7, _excluded5);
    return /*#__PURE__*/React.createElement(Button, _extends({
      size: "medium",
      skin: "dark"
    }, props), children);
  },
  Label: _ref8 => {
    let props = _extends({}, (_objectDestructuringEmpty(_ref8), _ref8));
    return /*#__PURE__*/React.createElement(Label, props);
  },
  LabelContainer: _ref9 => {
    let children = _ref9.children,
      premium = _ref9.premium,
      visible = _ref9.visible;
    return visible || premium ? /*#__PURE__*/React.createElement(Box, {
      gap: "6px",
      verticalAlign: "middle",
      flexWrap: "wrap"
    }, children) : null;
  },
  PricingWrapper: _ref0 => {
    let children = _ref0.children,
      props = _objectWithoutPropertiesLoose(_ref0, _excluded6);
    return /*#__PURE__*/React.createElement(Box, props, children);
  },
  PricingContent,
  TitleDisplay: _ref1 => {
    let children = _ref1.children,
      props = _objectWithoutPropertiesLoose(_ref1, _excluded7);
    return /*#__PURE__*/React.createElement(TitleDisplay, props, children);
  },
  ActionsContainer: _ref10 => {
    let children = _ref10.children,
      props = _objectWithoutPropertiesLoose(_ref10, _excluded8);
    return /*#__PURE__*/React.createElement(Box, _extends({
      gap: "16px",
      verticalAlign: "middle",
      align: "space-between",
      marginLeft: "auto"
    }, props), children);
  },
  /**
   * Mobile-only: lays out the pricing and action buttons under the domain
   * title. Default renders pricing on its own row, then the action row
   * (AI Insights ↔ Get It if AI Insights is present, otherwise Get It alone
   * right-aligned). Override at the call site to change the layout, e.g.
   * to render pricing inline with Get It on a single row.
   */
  MobileActions: _ref11 => {
    let pricing = _ref11.pricing,
      getItButton = _ref11.getItButton,
      aiInsightsButton = _ref11.aiInsightsButton,
      inline = _ref11.inline;
    return inline ? /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      align: "space-between",
      verticalAlign: "middle",
      width: "100%",
      gap: "SP4",
      flexWrap: "wrap"
    }, pricing, /*#__PURE__*/React.createElement(Box, {
      flexShrink: 0,
      marginLeft: "auto"
    }, getItButton)) : /*#__PURE__*/React.createElement(React.Fragment, null, pricing, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      align: aiInsightsButton ? 'space-between' : 'right',
      verticalAlign: "middle",
      width: "100%"
    }, aiInsightsButton, getItButton));
  },
  Divider: _ref12 => {
    let className = _ref12.className,
      dataHook = _ref12.dataHook;
    return /*#__PURE__*/React.createElement(Divider, {
      className: className,
      dataHook: dataHook
    });
  },
  HoverBox: _ref13 => {
    let children = _ref13.children,
      props = _objectWithoutPropertiesLoose(_ref13, _excluded9);
    return /*#__PURE__*/React.createElement(Box, props, children);
  },
  InlineExtras: _props => null,
  DomainNote: _props => null,
  Footer: _props => null
};
//# sourceMappingURL=SearchRecommendation.layout.js.map